import Vue from 'vue';

Vue.component('profit-index', () =>
    import(/* webpackChunkName: 'profit-index' */ './profit-index.vue'),
);
